import '../../components/css/glyhicon-spinner.css'

import { Col, Glyphicon, Grid, Row } from 'react-bootstrap'
import React, { Component } from 'react'
import { getDownload, getUpload } from '../../api/is4a.js'

import { Link } from 'react-router-dom'
import { axios } from 'config/axios'

export default class UploadFilePanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      uploading: false,
      uploaded: false,
      errored: false,
      id: null,
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChangeFile = this.handleChangeFile.bind(this)
  }

  handleSubmit(event) {
    event.preventDefault()
  }

  handleChangeFile(event) {
    const _this = this
    const file = event.target.files[0]
    const formData = new FormData()
    formData.append('file', file)
    this.setState({
      uploading: true,
      uploaded: false,
      errored: false,
      id: null,
    })
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    axios
      .post(getUpload(), formData, config)
      .then(function (response) {
        _this.setState({
          uploading: false,
          uploaded: true,
          errored: false,
          id: response.data,
        })
        _this.props.onFileUploaded(response.data, _this.props.name)
      })
      .catch(function () {
        _this.setState({
          uploading: false,
          uploaded: false,
          errored: true,
          id: null,
        })
      })
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <h4>{this.props.name}</h4>
          </Col>
        </Row>
        <Row>
          <Col xs={9} md={9}>
            <form
              method="POST"
              onSubmit={this.handleSubmit}
              encType="multipart/form-data"
              onChange={this.handleChangeFile.bind(this)}
            >
              <input type="file" name="file" />
            </form>
          </Col>
          <Col xs={3} md={3}>
            {this.state.uploading && (
              <span style={{ marginLeft: '10px' }} className="glyphicon glyphicon-repeat fast-right-spinner" />
            )}
            {this.state.uploaded && (
              <div>
                <Glyphicon glyph="ok" />
                <Link to={getDownload(this.state.id)} style={{ marginLeft: '10px' }}>
                  <Glyphicon glyph="download" />
                </Link>
              </div>
            )}
            {this.state.errored && <Glyphicon bsStyle="success" glyph="remove" />}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <small>{this.props.description}</small>
          </Col>
        </Row>
      </Grid>
    )
  }
}
